import { setShowSupplierModal } from '../State/showSupplierModal';
import fetchSupplier from '../Services/fetchSupplier';

export default () => async (dispatch) => {
  dispatch(setShowSupplierModal(false));
  dispatch(fetchSupplier());
}
